function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) {
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    rmINoBounceHelper.enable();
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
      rmINoBounceHelper.disable();
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    rmINoBounceHelper.enable();
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.scrollPosition = 0;
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    this.scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    window.scrollTo(0, this.scrollPosition);
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      if(Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) <= 767) return;
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();

    // DOM
    this.slider = this.querySelector('ul');                    // scroll container
    this.itemsSelector = 'li';
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider) return;

    // Infinite params
    this.COPIES = 4;            // number of full copies on EACH side (tune as you like)
    this.REBASE_MARGIN = 1;     // blocks from either end to trigger rebase

    // State
    this._ignoreScroll = false;
    this._infiniteSetupDone = false;
    this._initialLoadComplete = false;
    this._didInitialRebase = false;
    this._resizeTimer = null;
    this._scrollTimer = null;

    // Measurements
    this.itemWidth = 0;
    this.gap = 0;              // px gap between items
    this.unit = 0;             // itemWidth + gap
    this.slidesPerPage = 1;

    // Original items
    this.originalItems = Array.from(this.slider.querySelectorAll(this.itemsSelector));
    this.originalCount = this.originalItems.length;
    if (!this.originalCount) return;

    // Safari: kill scroll anchoring during mutations
    this.slider.style.overflowAnchor = 'none';
    // Remember initial snap type; keep off during programmatic jumps
    this._initialSnapType = getComputedStyle(this.slider).scrollSnapType || '';
    this.slider.style.scrollSnapType = 'none';

     // Check if we should use infinite scroll (only for slider/carousel mode)
     this.shouldUseInfinite = this.shouldUseInfiniteScroll();
     
     // Init
     if (this.shouldUseInfinite) {
       this.setupInfinite();
       this.centerBlockIndex = this.COPIES;
       this.centerBlockStartIndex = this.centerBlockIndex * this.originalCount;
       
       // Start at the center block for infinite scroll
       this.jumpToIndexFloat(this.centerBlockStartIndex, { smooth: false });
     }
     
     this.measure();
     this.update(true);

     // Enable smooth after stable position
     requestAnimationFrame(() => {
       this.slider.classList.add('smooth-scroll');
       this.slider.style.scrollSnapType = this._initialSnapType;
     });

    // Listeners
    this.slider.addEventListener('scroll', () => this.onScroll(), { passive: true });
    this.prevButton?.addEventListener('click', (e) => { e.preventDefault(); this.byItems(-1); });
    this.nextButton?.addEventListener('click', (e) => { e.preventDefault(); this.byItems(+1); });

    // Resize handling (preserve visual position)
    const ro = new ResizeObserver(() => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.onResize(), 150);
    });
    ro.observe(this.slider);

    // Mark initial load as complete shortly after first paint
    setTimeout(() => { this._initialLoadComplete = true; }, 600);

    // Re-measure once when images load (throttled)
    const throttle = (fn, wait) => {
      let t = 0;
      return (...args) => {
        if (t) return;
        fn(...args);
        t = setTimeout(() => (t = 0), wait);
      };
    };
    const remeasureOnce = throttle(() => this.onResize(true), 250);
    this.originalItems.forEach(li => {
      li.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', remeasureOnce, { once: true });
      });
    });
  }

   /** ----- Queries / math ----- */

   shouldUseInfiniteScroll() {
     // Check if we're in a slider/carousel mode vs grid mode
     const isMobile = window.innerWidth <= 767;
     const isTablet = window.innerWidth <= 989;
     
     // Check for carousel mode classes
     const isCarouselMode = this.slider.closest('.product__media-wrapper--carousel') !== null;
     
     // Check for slider classes
     const hasSliderClass = this.slider.classList.contains('slider--mobile') || 
                           this.slider.classList.contains('slider--tablet') ||
                           this.slider.classList.contains('slider--desktop');
     
     // Use infinite scroll if:
     // 1. We're on mobile/tablet (always use slider behavior)
     // 2. We're in carousel mode on desktop
     // 3. We have slider classes and are not in grid mode
     const shouldUse = isMobile || isTablet || isCarouselMode || (hasSliderClass && !this.isGridMode());
     
     return shouldUse;
   }
   
   isGridMode() {
     // Check if we're in grid mode (desktop, not carousel)
     const isDesktop = window.innerWidth > 989;
     const isCarouselMode = this.slider.closest('.product__media-wrapper--carousel') !== null;
     
     return isDesktop && !isCarouselMode;
   }

   get allItems() {
     return Array.from(this.slider.querySelectorAll(this.itemsSelector));
   }

  getGapPx() {
    const cs = getComputedStyle(this.slider);
    const raw = cs.getPropertyValue('grid-column-gap') ||
                cs.getPropertyValue('column-gap') ||
                cs.getPropertyValue('gap') || '0';
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : 0;
  }

  measure() {
    const firstVisible = this.allItems.find(el => el.offsetWidth > 0);
    if (!firstVisible) return;
    this.itemWidth = firstVisible.offsetWidth;
    this.gap = this.getGapPx();
    this.unit = this.itemWidth + this.gap;

    // Pages (left-most visible item)
    this.slidesPerPage = Math.max(1, Math.floor((this.slider.clientWidth + this.gap) / this.unit));
    this.logicalTotalPages = Math.max(1, this.originalCount - this.slidesPerPage + 1);
    if (this.pageTotal) this.pageTotal.textContent = this.logicalTotalPages;
  }

   /** ----- Infinite setup (multi-block cloning) ----- */

   removeClones() {
     // Remove all cloned elements
     const clones = this.slider.querySelectorAll('[data-clone]');
     clones.forEach(clone => clone.remove());
     this._infiniteSetupDone = false;
   }

   setupInfinite() {
     if (this._infiniteSetupDone) return;

    const beforeFrag = document.createDocumentFragment();
    const afterFrag = document.createDocumentFragment();

    // Build COPIES full blocks before and after
    for (let i = 0; i < this.COPIES; i++) {
      this.originalItems.forEach(node => {
        const c = node.cloneNode(true);
        c.setAttribute('data-clone', 'before');
        beforeFrag.appendChild(c);
      });
      this.originalItems.forEach(node => {
        const c = node.cloneNode(true);
        c.setAttribute('data-clone', 'after');
        afterFrag.appendChild(c);
      });
    }

    // Insert [before][original][after]
    this.slider.insertBefore(beforeFrag, this.slider.firstChild);
    this.slider.appendChild(afterFrag);

    this.totalBlocks = this.COPIES * 2 + 1;
    this._infiniteSetupDone = true;
  }


  /** ----- Indexing helpers ----- */

  // Physical fractional index in the giant list
  get indexFloat() {
    return this.unit ? this.slider.scrollLeft / this.unit : 0;
  }

  // Logical page (1-based) from physical fractional index
  logicalPageFromIndexFloat(idxFloat) {
    const withinOriginalsFloat =
      ((idxFloat - this.centerBlockStartIndex) % this.originalCount + this.originalCount) % this.originalCount;
    return Math.min(Math.max(Math.round(withinOriginalsFloat) + 1, 1), this.logicalTotalPages);
  }

  /** ----- Programmatic movement ----- */

  jumpToIndexFloat(indexFloat, { smooth = false } = {}) {
    if (!this.unit) this.measure();
    const left = indexFloat * this.unit;

    // Temporarily disable snap for hard jumps
    const oldSnap = this.slider.style.scrollSnapType;
    const oldBehavior = this.slider.style.scrollBehavior;
    this.slider.style.scrollSnapType = 'none';
    this.slider.style.scrollBehavior = smooth ? 'smooth' : 'auto';

    this._ignoreScroll = true;
    this.slider.scrollLeft = left;
    requestAnimationFrame(() => {
      this._ignoreScroll = false;
      // restore snap/behavior after two rAFs to ensure layout is settled
      requestAnimationFrame(() => {
        this.slider.style.scrollSnapType = oldSnap || this._initialSnapType || '';
        this.slider.style.scrollBehavior = oldBehavior || '';
      });
    });
  }

   byItems(delta) {
     if (this.shouldUseInfinite) {
       // Infinite mode: move by items
       const target = this.indexFloat + delta;
       this.jumpToIndexFloat(target, { smooth: true });
     } else {
       // Grid mode: move by pages
       const currentPage = this.logicalPageFromIndexFloat(this.indexFloat);
       const targetPage = Math.max(1, Math.min(this.logicalTotalPages, currentPage + delta));
       const targetIndex = (targetPage - 1) * this.slidesPerPage;
       this.jumpToIndexFloat(targetIndex, { smooth: true });
     }
     this.updateCountersAndMediaSoon();
   }

  gotoLogical(index /* 0-based within originals */) {
    // go to the same logical index within the center block
    const target = this.centerBlockStartIndex + index;
    this.jumpToIndexFloat(target, { smooth: true });
    this.updateCountersAndMediaSoon();
  }

  /** ----- Rebase near ends (true infinite) ----- */

  maybeRebaseNearEnds() {
    if (!this.unit) return false;

    const idxFloat = this.indexFloat;
    const blockIndex = Math.floor(idxFloat / this.originalCount);
    const within = idxFloat - blockIndex * this.originalCount;

    // Near left end?
    if (blockIndex <= this.REBASE_MARGIN) {
      this.jumpToIndexFloat(this.centerBlockStartIndex + within, { smooth: false });
      return true;
    }
    // Near right end?
    if (blockIndex >= this.totalBlocks - 1 - this.REBASE_MARGIN) {
      this.jumpToIndexFloat(this.centerBlockStartIndex + within, { smooth: false });
      return true;
    }
    return false;
  }

  /** ----- Event handlers ----- */

   onScroll() {
     if (this._ignoreScroll || !this.unit) return;

     // Debounce heavy work & rebase checks (only for infinite scroll)
     clearTimeout(this._scrollTimer);
     this._scrollTimer = setTimeout(() => {
       if (this.shouldUseInfinite) {
         this.maybeRebaseNearEnds();
       }
       this.updateCountersAndMediaSoon(0); // immediate after rebase
     }, 80);

     // Live counters update (cheap)
     const page = this.logicalPageFromIndexFloat(this.indexFloat);
     if (this.pageCount) this.pageCount.textContent = page;

     // Arrows stay enabled (infinite) or normal behavior (grid)
     if (this.shouldUseInfinite) {
       this.prevButton?.removeAttribute('disabled');
       this.nextButton?.removeAttribute('disabled');
     } else {
       // Normal button behavior for grid mode
       this.updateButtonStates();
     }
   }

   onResize(preserve = true) {
     if (!this.unit) this.measure();

     // Check if infinite scroll mode changed
     const newShouldUseInfinite = this.shouldUseInfiniteScroll();
     if (newShouldUseInfinite !== this.shouldUseInfinite) {
       this.shouldUseInfinite = newShouldUseInfinite;
       
       if (this.shouldUseInfinite) {
         // Switch to infinite mode
         this.setupInfinite();
         this.centerBlockIndex = this.COPIES;
         this.centerBlockStartIndex = this.centerBlockIndex * this.originalCount;
         this.jumpToIndexFloat(this.centerBlockStartIndex, { smooth: false });
       } else {
         // Switch to grid mode - remove clones
         this.removeClones();
         this.jumpToIndexFloat(0, { smooth: false });
       }
     }

     // Preserve current fractional *within block* (only for infinite mode)
     if (this.shouldUseInfinite && preserve) {
       const idxFloat = this.indexFloat;
       const blockIndex = Math.floor(idxFloat / this.originalCount);
       const within = idxFloat - blockIndex * this.originalCount;
       this.measure();
       this.jumpToIndexFloat(this.centerBlockStartIndex + within, { smooth: false });
     } else {
       this.measure();
     }
     
     this.update(true);
   }

  /** ----- UI sync & deferred media ----- */

  update(force = false) {
    if (!this.unit && !force) return;
    // After init, avoid repeated recenter
    if (!this._initialLoadComplete && !this._didInitialRebase) {
      // If we somehow didn’t land in center block, rebase once
      const idxFloat = this.indexFloat;
      const blockIndex = Math.floor(idxFloat / this.originalCount);
      if (blockIndex !== this.centerBlockIndex) {
        const within = idxFloat - blockIndex * this.originalCount;
        this.jumpToIndexFloat(this.centerBlockStartIndex + within, { smooth: false });
      }
      this._didInitialRebase = true;
    }

    const page = this.logicalPageFromIndexFloat(this.indexFloat);
    if (this.pageCount) this.pageCount.textContent = page;
    if (this.pageTotal) this.pageTotal.textContent = this.logicalTotalPages;
  }

   updateCountersAndMediaSoon(delay = 60) {
     clearTimeout(this._deferTimer);
     this._deferTimer = setTimeout(() => {
       const physicalIndex = Math.round(this.indexFloat);
       this.handleDeferredAtIndex(physicalIndex);
       const page = this.logicalPageFromIndexFloat(this.indexFloat);
       if (this.pageCount) this.pageCount.textContent = page;
     }, delay);
   }
   
   updateButtonStates() {
     // Normal button behavior for grid mode (not infinite)
     const currentPage = this.logicalPageFromIndexFloat(this.indexFloat);
     
     if (this.prevButton) {
       this.prevButton.disabled = currentPage <= 1;
     }
     if (this.nextButton) {
       this.nextButton.disabled = currentPage >= this.logicalTotalPages;
     }
   }

  /** ----- Your deferred-media logic (kept) ----- */
  handleDeferredAtIndex(physicalIndex) {
    const items = this.allItems;
    const cur = items[physicalIndex];
    const prev = items[physicalIndex - 1] || null;
    if (!cur) return;

    const deferred = cur.querySelector('.deferred-media');
    const prevDeferred = prev ? prev.querySelector('.deferred-media') : null;

    if (deferred) {
      const img = cur.querySelector('.product__modal-opener .product__media img');
      if (img) img.style.opacity = 0;

      deferred.style.display = 'block';
      deferred.style.position = 'absolute';
      deferred.style.top = 0;
      deferred.style.left = 0;
      deferred.style.width = '100%';

      const vid = deferred.querySelector('video');
      if (vid) {
        vid.play();
        vid.muted = !vid.muted;
      } else if (typeof deferred.loadContent === 'function') {
        deferred.loadContent();
      }

      deferred.dataset.paused = false;
      deferred.dataset.playing = true;
    }

    if (prevDeferred) {
      const prevVid = prevDeferred.querySelector('video');
      if (prevVid) {
        prevVid.pause();
        prevDeferred.dataset.paused = true;
        prevDeferred.dataset.playing = false;
      }
    }
  }
}

customElements.define('slider-component', SliderComponent);



class PrimaryUpsell extends HTMLElement {
  constructor() {
    super();
    this.upsellOption = document.getElementById('rm-selected-upsell');
    this.variantsData = JSON.parse(this.querySelector('#product-upsell-variants').textContent);
    this.upsellsData = JSON.parse(document.getElementById('product-upsell-product').textContent);
    
    this.select = this.querySelector('.select');
    this.input = this.querySelector('input[type="checkbox"]');
    
    if (this.select) {
      this.selectValue = this.querySelector('.select__select--value');
      this.selectDropdown = this.querySelector('.select__select--dropdown');
      this.selectDropdownOptions = Array.from(this.selectDropdown.querySelectorAll('.select__select--dropdown-option'));

      this.selectValue.addEventListener('click', this.toggleDropdown.bind(this));
      
      this.select.dataset.value = this.input.checked ? 1 : 0;
      this.selectValue.classList.add(this.selectValue.textContent.toLowerCase().trim().replace(/\s/g, '-').replace(/[^a-z0-9-]/g, ''));
      this.select.addEventListener('change', this.onSelectChange.bind(this));
      for(let i=0;i<this.selectDropdownOptions.length;i++) {
        this.selectDropdownOptions[i].addEventListener('click', this.onSelectChange.bind(this, this.selectDropdownOptions[i]));
      }

      let el = this;
      document.addEventListener('click', (e) => {
        if((e.target.classList.contains('select__select--dropdown') || e.target.classList.contains('select__select--value') || e.target.closest('.select__select--dropdown') != null)) return;
        if(el.selectDropdown.style.display == 'block') el.selectDropdown.style.display = 'none';
        else return;
      })
    }
    
    this.setup();
  }

  onSelectChange(option) {
    if (!this.select) return;
    
    this.selectDropdownOptions.find(option => option.dataset.selected == "true").dataset.selected = false;
    this.select.dataset.value = option.dataset.value;
    option.dataset.selected = true;
    this.selectValue.innerHTML = option.innerHTML;
    this.selectValue.setAttribute('class', 'select__select--value');
    this.selectValue.classList.add(option.textContent.toLowerCase().trim().replace(/\s/g, '-').replace(/[^a-z0-9-]/g, ''));
    if(parseInt(option.dataset.value)) {
      this.input.checked = true;
      this.input.setAttribute('checked', 'checked');
    } else {
      this.input.checked = false;
      this.input.removeAttribute('checked');
    }
    this.toggleDropdown();
  }

  documentClick(e) {
    alert('clicked');
    if(e.target.classList.contains('select__select--dropdown') || e.target.closest('.select__select--dropdown') != null) return;
    this.toggleDropdown();
  }

  toggleDropdown() {
    if (!this.selectDropdown) return;
    this.selectDropdown.style.display = this.selectDropdown.style.display == 'block' ? 'none' : 'block';
  }

  setup() {
    let selects = document.querySelectorAll('variant-selects, variant-radios');
    if(selects == null) return;
    let element = this;
    window.addEventListener('DOMContentLoaded', () => {
      selects.forEach(select => {
        element.onVariantChange(select);
        select.addEventListener('change', () => {
          element.onVariantChange(select);
        });
      });
    });
  }

  onVariantChange(select) {
    let currentVariant = select.getCurrentVariant();
    let upsellData = this.getUpsellData(currentVariant);
    if(upsellData) {
      this.upsellOption.value = upsellData.id;
      this.upsellOption.dataset.id = upsellData.id;
      
      if (this.input) {
        this.input.value = upsellData.id;
        this.input.dataset.id = upsellData.id;
      }
      
      this.querySelectorAll('.rm-main-product-upsell-price').forEach((el) => {
        el.textContent = new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: this.dataset.currency,
        }).format(upsellData.price / 100);
      });
      
      if (this.input && !this.select) {
        const unavailableText = this.querySelector('.rm-unavailable-text');
        if (upsellData.available) {
          this.input.disabled = false;
          if (unavailableText) {
            unavailableText.style.display = 'none';
          }
        } else {
          this.input.disabled = true;
          this.input.checked = false;
          if (unavailableText) {
            unavailableText.style.display = 'inline';
          }
        }
      }
    } else {
      this.upsellOption.value = '';
      this.upsellOption.dataset.id = '';
      
      if (this.input) {
        this.input.value = '';
        this.input.dataset.id = '';
      }
      
      if (this.input && !this.select) {
        this.input.disabled = true;
        this.input.checked = false;
      }
    }
  }

  getUpsellData(currentVariant) {
    let crosssellData = this.variantsData.find(item => { return currentVariant.id == item.id });
    if (!crosssellData || !crosssellData.upsellId) return false;
    let upsell = this.upsellsData.find(item => { return crosssellData.upsellId == item.id });
    return upsell != null ? upsell : false;
  }
}

customElements.define('primary-upsell', PrimaryUpsell);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    if (typeof super.connectedCallback === 'function') {
      super.connectedCallback();
    }

    this.updateOptions();
    this.updateMasterId();

    if (this.currentVariant) {
      this.rmUpdateElements();
    } else {
      this.updateSelectedOptionStockMessages();
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.rmUpdateElements();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      
      // Dispatch variant:change event for other components to listen to
      const variantChangeEvent = new CustomEvent('variant:change', {
        detail: { variant: this.currentVariant },
        bubbles: true
      });
      document.dispatchEvent(variantChangeEvent);
    }
  }

  rmUpdateElements() {
    const inStockElem = document.querySelector('.rm-product-single-in-stock');
    const lowStockElem = document.querySelector('.rm-product-single-low-stock');
    const oosElem = document.querySelector('.rm-product-single-oos');
    const deliveryTimer = document.querySelector('.rm-delivery-timer');
    this.updateSelectedOptionStockMessages();
    if (!this.currentVariant) {
      if (inStockElem != null) inStockElem.classList.remove('rm-shown-flex');
      if (lowStockElem != null) lowStockElem.classList.remove('rm-shown-flex');
      if (oosElem != null) oosElem.classList.remove('rm-shown-flex');
      if (deliveryTimer != null) deliveryTimer.classList.remove('rm-shown-flex');
      return;
    }

    let currVariantQty = undefined;
    if (typeof rmVariantQuantities !== 'undefined' && rmVariantQuantities !== null) {
      currVariantQty = parseInt(rmVariantQuantities[this.currentVariant.id]);
    }

    if (Number.isNaN(currVariantQty) || typeof currVariantQty === 'undefined') {
      const inventoryQty = this.currentVariant.inventory_quantity;
      currVariantQty = typeof inventoryQty === 'number' ? inventoryQty : 0;
    }
    const urgencyMessage = document.querySelector('.rm-product-message');

    // Hide all stock indicators first
    if(inStockElem != null) inStockElem.classList.remove('rm-shown-flex');
    if(lowStockElem != null) lowStockElem.classList.remove('rm-shown-flex');
    if(oosElem != null) oosElem.classList.remove('rm-shown-flex');

    if (currVariantQty < 1) {
      // Out of stock
      if(deliveryTimer != null) deliveryTimer.classList.remove('rm-shown-flex');
      if(oosElem != null) oosElem.classList.add('rm-shown-flex');
    } else if (currVariantQty < 15) {
      // Low stock (1-14 items)
      if(lowStockElem != null) lowStockElem.classList.add('rm-shown-flex');
      if(deliveryTimer != null) deliveryTimer.classList.add('rm-shown-flex');
    } else {
      // In stock (15+ items)
      if(inStockElem != null) inStockElem.classList.add('rm-shown-flex');
      if(deliveryTimer != null) deliveryTimer.classList.add('rm-shown-flex');
    }

    if(urgencyMessage != null) {
      const currentVariant = this.currentVariant;
      const supplemental = this.getSupplementalData().find((variant) => {
        return variant.id == currentVariant.id;
      })
      if(supplemental != null && typeof supplemental.msg != 'undefined') {
        urgencyMessage.querySelector('.rm-product-message-inner').classList.remove('hidden');
        urgencyMessage.querySelector('.rm-product-message-text').textContent = supplemental.msg;
      } else {
        if(urgencyMessage.querySelector('.rm-product-message-inner').getAttribute('data-initially-visible') != "true") {
          urgencyMessage.querySelector('.rm-product-message-inner').classList.add('hidden');
        }
        urgencyMessage.querySelector('.rm-product-message-text').textContent = urgencyMessage.querySelector('.rm-product-message-text').getAttribute('data-original-text');
      }
    }
  }

  shouldHideSoldOut() {
    const value = this.dataset.hideSoldOut;
    if (typeof value === 'undefined' || value === null) return false;
    return value === 'true' || value === '1';
  }

  getStockSuffixFromQuantity(quantity) {
    if (typeof quantity !== 'number') return '';
    if (quantity < 1) {
      return this.shouldHideSoldOut() ? '' : ' - Out of stock';
    }
    if (quantity < 15) {
      return ' - Low Stock';
    }
    return '';
  }

  updateSelectedOptionStockMessages() {
    if (!Array.isArray(this.options)) {
      this.updateOptions();
    }

    const variants = this.getVariantData();
    if (!Array.isArray(variants) || !variants.length) {
      return;
    }

    const hideSoldOut = this.shouldHideSoldOut();

    const selectElements = Array.from(this.querySelectorAll('select.select__select'));
    selectElements.forEach((select, fallbackIndex) => {
      const optionIndex = select.dataset.optionIndex !== undefined
        ? parseInt(select.dataset.optionIndex, 10)
        : fallbackIndex;
      if (Number.isNaN(optionIndex)) return;

      Array.from(select.options).forEach((option) => {
        if (!option.dataset.originalText) {
          option.dataset.originalText = option.textContent.trim();
        }

        if (option.disabled || option.hasAttribute('data-placeholder-option')) {
          option.textContent = option.dataset.originalText;
          return;
        }

        const baseText = option.dataset.optionLabel
          || option.dataset.baseText
          || this.stripStockSuffix(option.dataset.originalText || option.textContent);
        option.dataset.baseText = baseText;

        const suffix = this.computeOptionStockSuffix(optionIndex, option.value, variants, hideSoldOut);
        option.textContent = `${baseText}${suffix}`;
      });
    });

    const radios = this.querySelectorAll('input[type="radio"]');
    radios.forEach((radio) => {
      const fallbackIndex = (() => {
        const fieldset = radio.closest('fieldset');
        if (!fieldset) return 0;
        const siblingFieldsets = Array.from(fieldset.parentElement.querySelectorAll('fieldset'));
        const index = siblingFieldsets.indexOf(fieldset);
        return index > -1 ? index : 0;
      })();

      const optionIndex = radio.dataset.optionIndex !== undefined
        ? parseInt(radio.dataset.optionIndex, 10)
        : fallbackIndex;
      if (Number.isNaN(optionIndex)) return;
      const label = this.querySelector(`label[for="${radio.id}"]`);
      if (!label) return;

      if (!label.dataset.originalText) {
        label.dataset.originalText = label.textContent.trim();
      }

      const baseText = label.dataset.optionLabel
        || label.dataset.baseText
        || this.stripStockSuffix(label.dataset.originalText || label.textContent);
      label.dataset.baseText = baseText;

      const suffix = this.computeOptionStockSuffix(optionIndex, radio.value, variants, hideSoldOut);
      label.textContent = `${baseText}${suffix}`;
    });
  }

  stripStockSuffix(text) {
    if (typeof text !== 'string') return '';
    return text.replace(/\s+-\s+(Low Stock|Out of stock)$/i, '');
  }

  computeOptionStockSuffix(optionIndex, optionValue, variants, hideSoldOut) {
    if (!Array.isArray(variants)) return '';

    let anyMatch = false;
    let anyAvailable = false;
    let anyLowStock = false;

    variants.forEach((variant) => {
      if (!variant || !Array.isArray(variant.options)) return;
      if (variant.options[optionIndex] !== optionValue) return;

      if (!this.variantMatchesCurrentSelections(variant, optionIndex)) return;

      anyMatch = true;

      if (variant.available) {
        anyAvailable = true;
        const qty = this.getVariantInventoryQuantity(variant);
        if (qty > 0 && qty < 15) {
          anyLowStock = true;
        }
      }
    });

    if (!anyMatch) return '';

    if (!anyAvailable) {
      return hideSoldOut ? '' : ' - Out of stock';
    }

    if (anyLowStock) {
      return ' - Low Stock';
    }

    return '';
  }

  variantMatchesCurrentSelections(variant, optionIndex) {
    if (!Array.isArray(variant.options)) return false;

    if (!Array.isArray(this.options)) {
      this.updateOptions();
    }

    return variant.options.every((variantOption, index) => {
      if (index === optionIndex) return true;
      const selectedValue = Array.isArray(this.options) ? this.options[index] : null;
      if (selectedValue === null || typeof selectedValue === 'undefined' || selectedValue === '') {
        return true;
      }
      return variantOption === selectedValue;
    });
  }

  getVariantInventoryQuantity(variant) {
    if (!variant) return 0;

    // First try the global rmVariantQuantities map
    if (typeof rmVariantQuantities !== 'undefined' && rmVariantQuantities !== null && variant.id) {
      const storedQty = parseInt(rmVariantQuantities[variant.id], 10);
      if (!Number.isNaN(storedQty)) {
        return storedQty;
      }
    }

    // Fall back to variant.inventory_quantity
    if (typeof variant.inventory_quantity !== 'undefined') {
      const qty = typeof variant.inventory_quantity === 'number'
        ? variant.inventory_quantity
        : parseInt(variant.inventory_quantity, 10);
      if (!Number.isNaN(qty)) {
        return qty;
      }
    }

    return 0;
  }

  updateOptions() {
    const selects = Array.from(this.querySelectorAll('select.select__select'));
    if (!selects.length) {
      this.options = [];
      return;
    }

    this.options = selects.map((select) => {
      const selectedOption = select.options[select.selectedIndex];
      if (!selectedOption || selectedOption.disabled || selectedOption.hasAttribute('data-placeholder-option')) {
        return null;
      }
      return selectedOption.value;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    parent.append(parent.firstChild);
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({behavior: "smooth"}); });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.rmUpdateAddToCartForm(this.currentVariant.available);
      });
  }

  rmUpdateAddToCartForm(variantAvailable) {

    let currVariantQty = undefined;
    if (typeof rmVariantQuantities !== 'undefined' && rmVariantQuantities !== null) {
      currVariantQty = parseInt(rmVariantQuantities[this.currentVariant.id]);
    }

    if (Number.isNaN(currVariantQty) || typeof currVariantQty === 'undefined') {
      const inventoryQty = this.currentVariant?.inventory_quantity;
      currVariantQty = typeof inventoryQty === 'number' ? inventoryQty : 0;
    }
    const paymentButton = document.querySelector('.rm-shopify-payment-button-wrapper');
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (currVariantQty < 1) {
      paymentButton && paymentButton.classList.add('hidden');
      addButtonText.textContent = variantAvailable ? window.variantStrings.rmBackOrder : window.variantStrings.soldOut;
    } else {
      paymentButton && paymentButton.classList.remove('hidden');
    }

  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  getSupplementalData() {
    this.supplementalData = this.supplementalData || JSON.parse(document.querySelector('[data-supplemental]').textContent);
    return this.supplementalData;
  }

  getCurrentVariant() {
    if(typeof this.currentVariant == 'undefined') {
      this.updateOptions();
      this.updateMasterId();
    }
    return this.currentVariant;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const selectedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      return selectedRadio ? selectedRadio.value : null;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Real Media

class RmCollapseBtnAboutUs extends HTMLElement {
  constructor() {
    super();

    this.toggleBtn = this.querySelector('.rm-about-us-more');
    this.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    const additionalContent = this.nextElementSibling;
    additionalContent.classList.toggle('rm-about-us-content-additional--active');

    if (additionalContent.classList.contains('rm-about-us-content-additional--active')) {
      this.toggleBtn.textContent = this.dataset.readLess;
    } else {
      this.toggleBtn.textContent = this.dataset.readMore;
    }
  }

}

customElements.define('rm-collapse-btn-about-us', RmCollapseBtnAboutUs);

class RmCollapseBtnFooter extends HTMLElement {
  constructor() {
    super();

    this.parentElement.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    this.classList.toggle('footer-block__heading--active');
    const content = this.nextElementSibling;
    content.classList.toggle('rm-footer-block--active');
  }

}

customElements.define('rm-collapse-btn-footer', RmCollapseBtnFooter);

class RmCollapsibleFaq extends HTMLElement {
  constructor() {
    super();

    // These classes come from custom fields. For each card we paste the markup in the code editor. 
    // Reason: There is no way to set the title separately and still remain flexible with the number of cards they can add.
    this.toggleBtn = this.querySelector('.rm-collapsible-faq-card-btn');
    this.content = this.querySelector('.rm-collapsible-faq-card-txt');

    if (this.toggleBtn && this.content) {
      this.addEventListener('click', this.toggleCollapse.bind(this));
    }
  }

  toggleCollapse() {
    this.content.classList.toggle('rm-collapsible-faq-card--active');
  }

}

customElements.define('rm-collapsible-faq', RmCollapsibleFaq);

// TODO Refactor and merge these into one class
class RmCollapseBtnBlogSeo extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.toggleCollapse);
  }

  toggleCollapse() {
    const seoText = this.previousElementSibling;
    const btnText = this.querySelector('.rm-blog-seo-expand-btn-txt');
    seoText.classList.toggle('rm-blog-seo-text--active');
    this.classList.toggle('rm-blog-seo-btn--active')

    if (seoText.classList.contains('rm-blog-seo-text--active')) {
      btnText.textContent = 'Less';
    } else {
      btnText.textContent = 'More';
    }
  }

}

customElements.define('rm-collapse-blog-seo', RmCollapseBtnBlogSeo);

class RmAdBanners extends HTMLElement {
  constructor() {
    super();

    // TODO Add event tracking for Google Analytics
  }

}

customElements.define('rm-ad-banners', RmAdBanners);

class RmContentSlider {
  constructor(selector, breakpoints, initialWidth) {

    this.sectionGliders = document.querySelectorAll(selector);

    this.addEventListeners()
    this.initGlider(breakpoints, initialWidth);
  }

  initGlider(breakpoints, initialWidth) {
    this.sectionGliders.forEach(function (ele) {
      new Glider(ele, {
        slidesToShow: 'auto',
        slidesToScroll: 1,
        itemWidth: initialWidth ? initialWidth : undefined,
        exactWidth: initialWidth ? true : false,
        scrollLock: true,
        draggable: false,
        dots: ele.parentNode.querySelector('.dots'),
        arrows: {
          prev: ele.parentNode.querySelector('.glider-prev'),
          next: ele.parentNode.querySelector('.glider-next')
        },
        responsive: breakpoints ? breakpoints : []
      });
    });
  }

  addEventListeners() {
    this.sectionGliders.forEach(function (section) {
      section.addEventListener('glider-loaded', function() {
        section.closest('.rm-content-slider').style.visibility = 'visible';
      })
    });

    // document.addEventListener('glider-loaded', this.hideFFScrollBars);
    // document.addEventListener('glider-refresh', this.hideFFScrollBars);
  }

  hideFFScrollBars(e){
    const scrollbarHeight = 17; // Currently 17, may change with updates
    if(/firefox/i.test(navigator.userAgent)){
      // We only need to apply to desktop. Firefox for mobile uses
      // a different rendering engine (WebKit)
      if (window.innerWidth > 575){
        e.target.parentNode.style.height = (e.target.offsetHeight - scrollbarHeight) + 'px';
      }
    }
  }

}

class RmFloatingFilterBtn extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    // Menu drawer dependency
    this.facetsMenuDrawer = document.querySelector('.mobile-facets__wrapper');

    this.productContainer = document.getElementById('AjaxinateContainer');

    this.addEventListener('click', this.facetsMenuDrawer.onSummaryClick.bind(this.facetsMenuDrawer));
    document.addEventListener("scroll", this.showOrHideBtn.bind(this));

    this.showOrHideBtn()
  }

  showOrHideBtn() {
    const currFacetsMenuLocation = this.facetsMenuDrawer.getBoundingClientRect().top + window.scrollY;
    const productContainerBotLoc = this.productContainer.getBoundingClientRect().bottom + window.scrollY;
    if (window.scrollY > (currFacetsMenuLocation + 48) && window.scrollY < productContainerBotLoc) {
      this.classList.add("rm-floating-filterbtn--show");
    } else {
      this.classList.remove("rm-floating-filterbtn--show");
    }
  }

}

customElements.define('rm-floating-filter', RmFloatingFilterBtn);

class RmHamburgerMenuCloseExtension extends HeaderDrawer {
  constructor() {
    super();

    this.headerDrawer = document.querySelector('header-drawer');
    this.headerSummary = this.headerDrawer.querySelector('summary');

    this.addEventListener('click', this.closeHamburgerMenu)

  }

  closeHamburgerMenu() {
    this.headerDrawer.closeMenuDrawer(this.headerSummary);
  }

}

customElements.define('rm-hamburger-close', RmHamburgerMenuCloseExtension);

class rmINoBounceHelper {

  static isIOS() {
    return /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
  }

  static enable() {
    if (!iNoBounce.isEnabled() && rmINoBounceHelper.isIOS()) {
      iNoBounce.enable();
    }
  }

  static disable() {
    if (iNoBounce.isEnabled() && rmINoBounceHelper.isIOS()) {
      iNoBounce.disable();
    }
  }

}

class RmCollapsibleTab extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', () => {
      window.openOffCanvas(this);
    })
  }
}

customElements.define('rm-collapsible-tab', RmCollapsibleTab);

class LocationSelector extends HTMLElement {
  constructor() {
    super();

    const link = this.querySelector('a');
    link.addEventListener('click', this.triggerLocationModal.bind(this));
  }

  async triggerLocationModal() {
    const locationSelector = this;
    const locationFetchURL = window.Shopify.routes.root
      + 'browsing_context_suggestions.json'
      + '?country[enabled]=true'
      + `&country[exclude]=${window.Shopify.country}`
      + '&language[enabled]=true'
      + `&language[exclude]=${window.Shopify.language}`;
    await fetch(locationFetchURL).then(async r => {
      let data = await r.json();
      if (typeof data.suggestions == null || typeof data.suggestions == 'undefined' || data.suggestions.length < 1) return;
      if(typeof data.suggestions[0].parts.country == 'undefined') {
        data.suggestions[0].parts.country = {
          "handle": data.detected_values.country.handle || 'GB',
          "name": data.detected_values.country.name || 'United Kingdom',
          "confidence": 1,
          "options": {}
        }
        for(let country in LocaleBar.data.countries) {
          data.suggestions[0].parts.country.options[country] = LocaleBar.data.countries[country].country_name.en
        }
      }
      LocaleBar.style.innerHTML = ".locale-bar__container{font-size:16px;outline:none;z-index:1000000}.locale-bar__content{align-items:flex-start;display:flex;justify-content:space-between;padding:1em}.locale-bar__message{margin:0;padding:0}.locale-bar__form{margin:0.5em 0 0 -0.3em;text-align:left}.locale-bar__selector{-moz-appearance:none !important;-webkit-appearance:none !important;appearance:none !important;background-color:#f4f4f4 !important;background-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjUiPjxwYXRoIGZpbGw9IiM2NjYiIGQ9Ik0wIDBzMy40IDQuNCAzLjUgNC40QzMuNyA0LjQgNy4xIDAgNy4xIDBIMHoiLz48L3N2Zz4=\") !important;background-position:right 10px center !important;background-repeat:no-repeat !important;background-size:auto !important;border-radius:2px !important;border:0 !important;color:#333 !important;cursor:pointer !important;display:inline-block !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;margin:0.3em !important;max-width:100% !important;min-height:unset !important;min-width:unset !important;padding:0.3em 28px 0.3em 0.5em !important;text-indent:0.01px !important;text-overflow:\'\' !important;vertical-align:baseline !important;width:auto !important}.locale-bar__button{border:none !important;box-shadow:none !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;min-height:unset !important;min-width:unset !important;text-align:center !important;vertical-align:unset !important;width:auto !important;border:none;border-radius:2px;box-shadow:none;margin:0.3em;padding:0.3em 0.5em}.locale-bar__button:hover,.locale-bar__button:focus{border:none !important;box-shadow:none !important;min-width:unset !important;width:auto !important}.locale-bar__button:focus{outline:auto !important}.locale-bar__button:hover{box-shadow:inset 0 0 0 100px rgba(0,0,0,0.15)}.locale-bar__button--minimal{border:none !important;box-shadow:none !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;min-height:unset !important;min-width:unset !important;text-align:center !important;vertical-align:unset !important;width:auto !important;background:none !important;padding:0 !important;text-decoration:underline}.locale-bar__button--minimal:hover,.locale-bar__button--minimal:focus{border:none !important;box-shadow:none !important;min-width:unset !important;width:auto !important}.locale-bar__button--minimal:focus{outline:auto !important}.locale-bar__button--minimal:hover,.locale-bar__button--minimal:focus{background:none !important}.locale-bar__close-button{border:none !important;box-shadow:none !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;min-height:unset !important;min-width:unset !important;text-align:center !important;vertical-align:unset !important;width:auto !important;background:none !important;padding:0 !important;margin-left:1em;padding-top:2px}.locale-bar__close-button:hover,.locale-bar__close-button:focus{border:none !important;box-shadow:none !important;min-width:unset !important;width:auto !important}.locale-bar__close-button:focus{outline:auto !important}.locale-bar__close-button:hover,.locale-bar__close-button:focus{background:none !important}.recommendation-modal__container{box-shadow:0px 0px 1px rgba(0,0,0,0.3),0px 4px 4px 1px rgba(0,0,0,0.1);max-width:30em;position:fixed;left:50%;top:50%;transform:translate(-50%, -50%);width:calc(100% - 2em);z-index:1000000;border-radius:5px}.recommendation-modal__close-button-container{display:flex;justify-content:flex-end}.recommendation-modal__close-button{border:none !important;box-shadow:none !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;min-height:unset !important;min-width:unset !important;text-align:center !important;vertical-align:unset !important;width:auto !important;background:none !important;padding:0 !important;margin-right:10px;margin-top:10px}.recommendation-modal__close-button:hover,.recommendation-modal__close-button:focus{border:none !important;box-shadow:none !important;min-width:unset !important;width:auto !important}.recommendation-modal__close-button:focus{outline:auto !important}.recommendation-modal__close-button:hover,.recommendation-modal__close-button:focus{background:none !important}.recommendation-modal__content{display:flex;flex-direction:column;align-items:center;padding:0 2.5em 2.5em}@media (max-width: 750px){.recommendation-modal__content{padding:0 2em 2em}}.recommendation-modal__flag{padding-top:12px}.recommendation-modal__flag img{width:75px !important;height:48px !important}.recommendation-modal__message,.recommendation-modal__message--align-start{font-weight:normal !important;text-transform:none;margin:12px 0 25px !important;text-align:center;letter-spacing:normal;font-size:22px !important;line-height:1.3 !important}.recommendation-modal__message--align-start{align-self:flex-start}.recommendation-modal__message--bold{font-weight:bold !important}.recommendation-modal__benefits{width:100%}.recommendation-modal__benefits ul{margin:0 0 12px 0;padding-left:16px;font-size:16px}.recommendation-modal__benefits ul li{font-size:16px !important;line-height:1.4 !important;list-style-type:disc;margin-bottom:4px}.recommendation-modal__button{border:none !important;box-shadow:none !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;min-height:unset !important;min-width:unset !important;text-align:center !important;vertical-align:unset !important;width:auto !important;border:none;border-radius:4px;box-shadow:none;margin:0 !important;width:100% !important;height:52px !important;font-size:18px !important;box-sizing:border-box !important;padding:0 !important}.recommendation-modal__button:hover,.recommendation-modal__button:focus{border:none !important;box-shadow:none !important;min-width:unset !important;width:auto !important}.recommendation-modal__button:focus{outline:auto !important}.recommendation-modal__button:hover,.recommendation-modal__button:focus{cursor:pointer;width:100% !important}.recommendation-modal__button--minimal{border:none !important;box-shadow:none !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;min-height:unset !important;min-width:unset !important;text-align:center !important;vertical-align:unset !important;width:auto !important;background:none !important;padding:0 !important;margin-top:10px;text-decoration-line:underline;font-size:14px !important}.recommendation-modal__button--minimal:hover,.recommendation-modal__button--minimal:focus{border:none !important;box-shadow:none !important;min-width:unset !important;width:auto !important}.recommendation-modal__button--minimal:focus{outline:auto !important}.recommendation-modal__button--minimal:hover,.recommendation-modal__button--minimal:focus{background:none !important}.recommendation-modal__button--minimal:hover{cursor:pointer}.recommendation-modal__backdrop{background-color:rgba(0,0,0,0.3);display:block !important;height:100vh;left:0;position:fixed;top:0;width:100vw;z-index:999999}.recommendation-modal__selector--flag{-moz-appearance:none !important;-webkit-appearance:none !important;appearance:none !important;background-color:#f4f4f4 !important;background-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjUiPjxwYXRoIGZpbGw9IiM2NjYiIGQ9Ik0wIDBzMy40IDQuNCAzLjUgNC40QzMuNyA0LjQgNy4xIDAgNy4xIDBIMHoiLz48L3N2Zz4=\") !important;background-position:right 10px center !important;background-repeat:no-repeat !important;background-size:auto !important;border-radius:2px !important;border:0 !important;color:#333 !important;cursor:pointer !important;display:inline-block !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;margin:0.3em !important;max-width:100% !important;min-height:unset !important;min-width:unset !important;padding:0.3em 28px 0.3em 0.5em !important;text-indent:0.01px !important;text-overflow:\'\' !important;vertical-align:baseline !important;width:auto !important;background-color:transparent !important;border:1px solid #babfc3 !important;border-radius:4px !important;width:100% !important;height:38px !important;margin:0 !important;padding-left:40px !important}.recommendation-modal__selector{-moz-appearance:none !important;-webkit-appearance:none !important;appearance:none !important;background-color:#f4f4f4 !important;background-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjUiPjxwYXRoIGZpbGw9IiM2NjYiIGQ9Ik0wIDBzMy40IDQuNCAzLjUgNC40QzMuNyA0LjQgNy4xIDAgNy4xIDBIMHoiLz48L3N2Zz4=\") !important;background-position:right 10px center !important;background-repeat:no-repeat !important;background-size:auto !important;border-radius:2px !important;border:0 !important;color:#333 !important;cursor:pointer !important;display:inline-block !important;font-size:16px !important;height:auto !important;line-height:1.375 !important;margin:0.3em !important;max-width:100% !important;min-height:unset !important;min-width:unset !important;padding:0.3em 28px 0.3em 0.5em !important;text-indent:0.01px !important;text-overflow:\'\' !important;vertical-align:baseline !important;width:auto !important;background-color:transparent !important;border:1px solid #babfc3 !important;border-radius:4px !important;width:100% !important;height:38px !important;margin:0 !important}.recommendation-modal__selector-wrapper--flag{background-image:var(--bg-image);background-repeat:no-repeat;background-position:11px center;background-size:25px;background-color:#f4f4f4 !important;border-radius:4px !important;margin:0 0 12px 0}.recommendation-modal__selector-wrapper{background-color:#f4f4f4 !important;border-radius:4px !important;margin:0 0 12px 0}.recommendation-modal__form{margin:0;width:100%}.recommendation-modal__form button:last-of-type{margin-top:18px !important}\n"
      LocaleBar.render(data, JSON.parse("{\"colors\":{\"background\":\"#fff\",\"foreground\":\"#333333\",\"buttonBackground\":\"#8cd10b\",\"buttonForeground\":\"#000000\",\"link\":\"#a8a8a8\"},\"layout\":{\"minimal\":false,\"variant\":\"modal\"},\"messages\":{\"en\":{\"currency_and_language_suggestion\":\"Looks like you're in {{ country }}. Change language and currency?\",\"currency_suggestion\":\"Looks like you're in {{ country }}. Change currency?\",\"country_and_language_suggestion\":\"Looks like you're in {{ country }}. Change country and language?\",\"country_suggestion\":\"Looks like you're in {{ country }}. Change country?\",\"language_suggestion\":\"Looks like your browser is set to {{ language }}. Change language?\",\"submit\":\"Change\"}}}"))
    });
  }
}

customElements.define('location-selector', LocationSelector);

class RatingsSummary extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', () => {
      window.openOffCanvas(this);
    });
  }
}

customElements.define('ratings-summary', RatingsSummary);

// Quick Buy functionality
window.openQuickBuyFromCard = async function(productHandle, underlayData = null) {
  try {
    // Fetch product data from Shopify AJAX API
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error('Failed to fetch product data');
    }
    
    const productData = await response.json();
    
    // Add underlay data to product data if available
    if (underlayData) {
      productData.underlayData = underlayData;
    }
    
    // Open the quick buy popup with the product data
    if (window.quickBuyPopup) {
      await window.quickBuyPopup.open(productData);
    } else {
      console.error('Quick buy popup not initialized');
    }
  } catch (error) {
    console.error('Error opening quick buy popup:', error);
  }
};

// Enhanced quick buy function that gets underlay data from button attributes
window.openQuickBuyFromButton = async function(button, event) {
  // Prevent event bubbling to avoid conflicts with image clicks
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  
  const productHandle = button.getAttribute('data-product-handle') || button.closest('[data-product-handle]')?.getAttribute('data-product-handle');
  const underlayVariants = button.getAttribute('data-underlay-variants');
  const hideSoldOut = button.getAttribute('data-hide-sold-out');
  
  if (!productHandle) {
    console.error('No product handle found');
    return;
  }
  
  try {
    // Fetch product data from Shopify AJAX API
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) {
      throw new Error('Failed to fetch product data');
    }
    
    const productData = await response.json();
    
    // Add hide sold out preference to product data
    productData.hideSoldOut = hideSoldOut === 'true';
    
    // Parse underlay data if available
    if (underlayVariants) {
      const underlayData = {};
      const variants = underlayVariants.split('|');
      variants.forEach(variant => {
        const [variantId, underlayId, underlayPrice, underlayTitle, underlayAvailable] = variant.split(':');
        underlayData[variantId] = {
          id: parseInt(underlayId),
          price: parseInt(underlayPrice),
          title: underlayTitle,
          available: underlayAvailable === 'true'
        };
      });
      productData.underlayData = underlayData;
    }
    
    // Open the quick buy popup with the product data
    if (window.quickBuyPopup) {
      await window.quickBuyPopup.open(productData);
    } else {
      console.error('Quick buy popup not initialized');
    }
  } catch (error) {
    console.error('Error opening quick buy popup:', error);
  }
};
